import { render, staticRenderFns } from "./ThirdCopyReceiveDate.vue?vue&type=template&id=2c0da0c0&"
import script from "./ThirdCopyReceiveDate.vue?vue&type=script&lang=js&"
export * from "./ThirdCopyReceiveDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports